import type {SeedQuestionSource} from '@cp/model';
import {SeedQuestionStatus} from '@cp/model';
import type {SeedQuestion} from '@cp/model';
import {addDoc, serverTimestamp} from 'firebase/firestore';
import getSeedQuestionCollectionRef from './getSeedQuestionCollectionRef';
import getSeedQuestionDoc from './getSeedQuestionDoc';

export interface CreateSeedQuestionDocInput {
  questionText: string;
  topic: string;
  options: string[];
  answer: string;
  source: SeedQuestionSource;
}

export default async function createSeedQuestionDoc(
  moduleId: string,
  input: CreateSeedQuestionDocInput,
): Promise<SeedQuestion> {
  const col = getSeedQuestionCollectionRef(moduleId);
  const ref = await addDoc(col, {
    questionText: input.questionText,
    topic: input.topic,
    options: input.options,
    answer: input.answer,
    source: input.source,
    status: SeedQuestionStatus.ACTIVE,
    createdAt: serverTimestamp(),
  });
  return getSeedQuestionDoc(moduleId, ref.id);
}
